import React, { FC } from 'react'
import classNames from 'classnames'
import styles from 'styles/components/card.module.scss'
import text from 'styles/utility/text.module.scss'
import { FlexRow } from 'components/Flex'
import { Description } from 'components/Typography'
import { Spacer } from 'components/Utility'
import { FirebaseDocRefType } from 'firebase/index'

type Props = {
  handleStock: (stockRef: FirebaseDocRefType, type: 'plus' | 'minus') => void
  pickupableTime: string
  stock: number
  stockRef: FirebaseDocRefType
}

const StockCardRow: FC<Props> = React.memo((props) => {
  const { handleStock, pickupableTime, stock, stockRef } = props

  return (
    <FlexRow justifyContent={'between'}>
      <div>
        <p className={`${text.font_bold} ${text.font_xxlarge}`}>{pickupableTime}</p>
        <Spacer size={4} />
        <Description description={'受渡解禁分'} />
      </div>
      <FlexRow justifyContent={'between'}>
        <button
          className={styles.row__button}
          data-cy={`button-stock-minus-${pickupableTime.replace(':', '')}`}
          disabled={stock <= 0}
          onClick={() => handleStock(stockRef, 'minus')}
        >
          <img
            className={classNames(text.pointerEventsNone, text.userSelectNone)}
            src={stock <= 0 ? '/icon/grey/minus_28x29.svg' : '/icon/orange/minus.svg'}
            alt={'在庫を減らす'}
          />
        </button>
        <Spacer size={24} axis={'horizontal'} />
        <span
          className={classNames(text.font_xxlarge, text.pointerEventsNone, text.userSelectNone, {
            [text.color_orange_main]: stock === 0,
            [text.font_bold]: stock === 0,
          })}
          data-cy={`pickupable-stock-${pickupableTime.replace(':', '')}`}
          onTouchStart={(e) => e.preventDefault()}
        >
          {stock.toLocaleString()}
        </span>
        <Spacer size={24} axis={'horizontal'} />
        <button
          className={styles.row__button}
          data-cy={`button-stock-plus-${pickupableTime.replace(':', '')}`}
          onClick={() => handleStock(stockRef, 'plus')}
        >
          <img
            className={classNames(text.pointerEventsNone, text.userSelectNone)}
            src={'/icon/orange/plus.svg'}
            alt={'在庫を増やす'}
          />
        </button>
      </FlexRow>
    </FlexRow>
  )
})

export default StockCardRow
